// StockCountWareHouseWrapper.js
import React from 'react';
import { useParams } from 'react-router-dom';
import StockCountWareHouse from './StockCountWareHouse';

const StockCountWareHouseWrapper = (props) => {
  const { warehouseId } = useParams();
  return <StockCountWareHouse {...props} warehouseId={warehouseId} />;
};

export default StockCountWareHouseWrapper;